import Bridge from './bridge';
import {store} from '../../onboarding/store';
import {setCurrentStudent} from '../../onboarding/store/actions/students.jsx';

class UnityProfileActions {
    constructor () {
        this._initialize();
    }

    _initialize () {
        Bridge.addListener('SyncProfile', this._onSyncProfileMessage.bind(this));
        Bridge.addListener('ClearScratch', this._onClearScratchMessage.bind());

        console.debug('[UnityProfileActions._initialize] Initialized');
    }

    _onClearScratchMessage () {
        window.setTimeout(() => {
            // Refresh the page to clear everything
            window.location.reload();
        }, 500);
    }

    _onSyncProfileMessage (payload) {
        console.debug('[UnityProfileActions._onSyncProfileMessage] Received message', JSON.stringify(payload));

        try {
            const unityObject = JSON.parse(payload);
            const normalizedStudent = this._normalizeStudent(unityObject);
            store.dispatch(setCurrentStudent(normalizedStudent));

            console.debug('[UnityProfileActions._onSyncProfileMessage] Student synced', JSON.stringify(normalizedStudent));
        } catch (e) {
            console.error('[UnityProfileActions._onSyncProfileMessage] Error while parsing payload', e);
        }
    }

    _normalizeStudent (unityObject) {
        return {
            id: unityObject.PlayerId,
            name: unityObject.Name,
            storageKey: unityObject.PlayerId, // This key is used to store the student's data in the server
            sessionId: unityObject.SessionId,
            experienceLevel: unityObject.ExperienceLevel,
            currentChallenge: unityObject.CurrentChallenge,
            unlockedSprites: (unityObject.Sprites || []).reduce((acc, sprite) => {
                acc[sprite] = {
                    unlockedOn: Date.now()
                };
                return acc;
            }, {}),
            unlockedBackdrops: (unityObject.Backgrounds || []).reduce((acc, backdrop) => {
                acc[backdrop] = {
                    unlockedOn: Date.now()
                };
                return acc;
            }, {})
        };
    }
}

export default UnityProfileActions;
